import config from './config';
import {Toast} from 'mint-ui';
export default {
    $ajax(opts, succ){
        //var vuex = JSON.parse(localStorage.vuex);
        var uuid = localStorage.localUuid,
            token = localStorage.localToken;
      /*  if (opts.url != "/login/login" && opts.url != "/login/fast"  &&
            (  uuid == undefined || token == undefined )
          ){
            window.location.href ="#/login";
            return false;
        }*/

        console.log(token);

        opts.type = 'post';
        opts.data = opts.data || {};
        opts.data.uuid = uuid;
        opts.data.token = token;    
        opts = Object.assign(opts, {xhrFields: {withCredentials: true}});
        opts.url = config.apiHost+opts.url;
        return $.ajax(opts).fail(()=>{
            Toast('network error')
        })
    },
}


// WEBPACK FOOTER //
// ./src/utils.js